import { EditAccountForm } from "./edit_account.types";

export const DEFAULT_FORM_VALUES: EditAccountForm = {
  name: "",
  fullDomain: "",
  customDomain: false,
  fromEmailDomain: "",
  feedbackEmailRecipient: "",
  theme: "",
  sessionTtlInMinutes: 1200,
  liveTtlInMinutes: 120,
  real: false,
  senderName: "",
  owner: {
    id: undefined,
    name: "",
    email: "",
    password: "",
    passwordConfirmation: ""
  },
  notificationSettings: {
    messagesStatus: "",
    digestEmail: "",
    broadcastInvites: "",
    regularInvites: "",
    roleFilled: "",
    ownerRoleFilled: "",
    roleClosed: "",
    interestExpressed: "",
    interestsSummary: "",
    marketplaceRoleClosed: "",
    bookingApprovalRequests: "",
    feedbackRequest: "",
    roleInvites: "",
    roleChanged: ""
  },
  skillCategories: [],
  brandCategories: [],
  languageCategories: [],
  qualificationCategories: [],
  languageSettings: {
    allowedLocales: [],
    locale: "",
    dateFormatKey: "day_month",
    twelveHourClock: true,
    availableCurrencies: [],
    currency: ""
  }
};

export const normalizeText = (text: string) => text.toLowerCase().replace(/ /g, "");
